import React, { useMemo } from 'react'
import { useCart } from 'public/components/online_ordering/CartContext'
import { useFulfillment } from 'src/public/components/online_ordering/FulfillmentContext'
import { useTimeBasedRules } from 'public/components/online_ordering/TimeBasedRuleContext'
import { FulfillmentTimeDisplay } from './FulfillmentTimeDisplay'

interface FulfillmentTimeRowProps {
  className?: string
  testId: string
  translationPrefix: string
}

export const FulfillmentTimeRow: React.FC<FulfillmentTimeRowProps> = ({
  className,
  testId,
  translationPrefix
}) => {
  const { cart } = useCart()
  const { setFulfillmentTimeModalOpen, selectedDiningOptionBehaviorSchedules } =
    useFulfillment()
  const { selectionsInCartWithTBRs } = useTimeBasedRules()

  const asapAvailable = useMemo(
    () =>
      Boolean(selectedDiningOptionBehaviorSchedules?.asapAvailableNow) &&
      selectionsInCartWithTBRs.length === 0,
    [
      selectedDiningOptionBehaviorSchedules?.asapAvailableNow,
      selectionsInCartWithTBRs.length
    ]
  )

  return (
    <FulfillmentTimeDisplay
      className={className}
      testId={testId}
      translationPrefix={translationPrefix}
      cart={cart}
      onClick={() => setFulfillmentTimeModalOpen(true)}
      asapAvailable={asapAvailable}
    />
  )
}
